/**
 * A global namespace for `dragstart` event.
 */
const dragstartEvent = 'dragstart';
export default dragstartEvent;
